<script setup lang="ts">
import {onMounted, ref} from 'vue';
import {ElCheckboxButton, ElCheckboxGroup, ElOption, ElSelect} from 'element-plus';
import {DASHBOARD_ORGANISATIES, DashboardOrganisatie, DashboardPeriods} from 'common';
import {dashboardPeriods} from '@/base/callBackend.js';
import {dashboardOrgs, dashboardPeriod, laadDashboard} from '@/base/dashboardState.js';

const kwartalen = ref<string[]>([]);
const groepen   = ref<DashboardOrganisatie[]>([]);

onMounted(async () => {
    const periods: DashboardPeriods | undefined = await laadDashboard(() => dashboardPeriods());
    if (periods) {
        kwartalen.value = [...periods.kwartalen].reverse();
        if (!kwartalen.value.includes(dashboardPeriod.value)) {
            dashboardPeriod.value = periods.laatste;
        }
        groepen.value       = DASHBOARD_ORGANISATIES.filter(o => periods.groepen.includes(o.label));
        // a stored choice of a group this user may not see (another user on the same browser) would select nothing visible
        dashboardOrgs.value = dashboardOrgs.value.filter(l => periods.groepen.includes(l));
    }
});
</script>

<template>
    <div class="flex flex-row flex-wrap items-center gap-4 px-10 py-2 border-b border-gray-200">
        <span class="font-thin">Kwartaal</span>
        <div data-testid="dashboard-period-select">
            <el-select v-model="dashboardPeriod" class="w-32">
                <el-option v-for="q in kwartalen" :key="q" :value="q" :label="q"/>
            </el-select>
        </div>

        <span class="font-thin pl-4">Organisatie</span>
        <el-checkbox-group v-model="dashboardOrgs" class="flex" data-testid="dashboard-org-buttons">
            <el-checkbox-button v-for="o in groepen" :key="o.label" :value="o.label" border>
                {{ o.kort }}
            </el-checkbox-button>
        </el-checkbox-group>
        <span v-if="dashboardOrgs.length === 0" class="text-xs text-gray-500">alle organisaties</span>
    </div>
</template>
